import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './ag-header.css';
import App from './App';
import { Provider } from 'react-redux'
import store from '../src/App/store'
import setAuthorizationToken from './Utils/setAuthorizationToken';

setAuthorizationToken(localStorage.getItem('token'))

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
